const coreApiBaseUrl = import.meta.env.VITE_CORE_API_BASE_URL?.replace(/\/$/, '') ?? '';
const applicationId = import.meta.env.VITE_APPLICATION_ID ?? '';

export const coreConfig = {
  apiBaseUrl: coreApiBaseUrl,
  applicationId,
  defaultRoleName: import.meta.env.VITE_DEFAULT_ROLE_NAME || 'Employee',
  homepageRoute: import.meta.env.VITE_HOMEPAGE_ROUTE || '/dashboard',
  applicationDisplayName: import.meta.env.VITE_APPLICATION_DISPLAY_NAME || 'Passport',
  coreFrontendOrigin: import.meta.env.VITE_CORE_FRONTEND_ORIGIN?.replace(/\/$/, '') ?? '',
  onboardingReturnUrl: import.meta.env.VITE_ONBOARDING_RETURN_URL ?? '',
  onboardingNativeReturnUrl:
    import.meta.env.VITE_ONBOARDING_NATIVE_RETURN_URL || 'passport://auth/callback',
} as const;

export function assertCoreConfig(): void {
  if (!coreConfig.apiBaseUrl || !coreConfig.applicationId) {
    throw new Error(
      'Missing Core configuration. Set VITE_CORE_API_BASE_URL and VITE_APPLICATION_ID in .env'
    );
  }
}
